/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Club_Name_InvalidInputs */

const en_us2_club_name_invalid = /** @type {(inputs: Club_Name_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give the club a name of up to 60 characters.`)
};

const pt_br2_club_name_invalid = /** @type {(inputs: Club_Name_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dê um nome de até 60 letras ao clube.`)
};

const es_419_club_name_invalid = /** @type {(inputs: Club_Name_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponle al club un nombre de hasta 60 caracteres.`)
};

const pt_pt2_club_name_invalid = /** @type {(inputs: Club_Name_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dá ao clube um nome com até 60 caracteres.`)
};

const fr_fr2_club_name_invalid = /** @type {(inputs: Club_Name_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donne au club un nom de 60 caractères maximum.`)
};

const de_de2_club_name_invalid = /** @type {(inputs: Club_Name_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib dem Club einen Namen mit bis zu 60 Zeichen.`)
};

const it_it2_club_name_invalid = /** @type {(inputs: Club_Name_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dai al club un nome di massimo 60 caratteri.`)
};

/**
* | output |
* | --- |
* | "Give the club a name of up to 60 characters." |
*
* @param {Club_Name_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const club_name_invalid = /** @type {((inputs?: Club_Name_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Club_Name_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_club_name_invalid(inputs)
	if (locale === "es-419") return es_419_club_name_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_club_name_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_club_name_invalid(inputs)
	if (locale === "de-DE") return de_de2_club_name_invalid(inputs)
	if (locale === "it-IT") return it_it2_club_name_invalid(inputs)
	return en_us2_club_name_invalid(inputs)
});
export { club_name_invalid as "club.name_invalid" }